// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__MLHVQDiscrepanciesCheckPopup__discrepancy-item-title{font-weight:700}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/ml-capability-quoteandbind-common-react/pages/MLHVQDiscrepanciesCheck/MLHVQDiscrepanciesCheckPopup.module.scss"],"names":[],"mappings":"AAAA,2DACI,eAAA","sourcesContent":[".discrepancy-item-title {\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"discrepancy-item-title": "app__MLHVQDiscrepanciesCheckPopup__discrepancy-item-title"
};
export default ___CSS_LOADER_EXPORT___;
